import { setPageIndex } from 'modules/main/store/ducks/mainSearch.actions';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';

import { SearchContextHeaderData } from './SearchContextHeaderData';
import { useSearchContextHeaderFetchPage } from './useSearchContextHeaderFetchPage';
import { useSearchContextHeaderInput } from './useSearchContextHeaderInput';

type Props = {
  currentObjectId: string;
};

export function useSearchContextHeader({ currentObjectId }: Props): {
  searchContext: SearchContextHeaderData | undefined;
} {
  const dispatch = useMainDispatch();

  const { searchContextInput, isSearching } = useSearchContextHeaderInput({
    currentObjectId,
  });

  useSearchContextHeaderFetchPage({ searchContextInput, isSearching });

  if (!searchContextInput) return { searchContext: undefined };

  const {
    currentResultIndex,
    pageIndex,
    resultsByPage,
    searchResultsPath,
    previousResult,
    previousResultPageIndex,
    nextResult,
    nextResultPageIndex,
    originatingPathname,
  } = searchContextInput;

  const results = resultsByPage[pageIndex];
  const resultIndex =
    (results.hitsPerPage || 0) * results.page + currentResultIndex;

  const searchContext = {
    searchResultsPath,
    previousResult,
    previousResultPageIndex,
    nextResult,
    nextResultPageIndex,
    resultIndex,
    originatingPathname,
    totalResults: results.nbHits,
    setPageIndex: (newPageIndex: number, didUserChange: boolean) =>
      dispatch(setPageIndex(newPageIndex, didUserChange)),
  } satisfies SearchContextHeaderData;

  return { searchContext };
}
